import { type IFlowAction } from 'widgets/Flow'

export const getChildActionsByIdAndType = <T>({
  id,
  getActionById,
  type,
}: {
  id: string
  getActionById: (id: string) => IFlowAction | undefined
  type: T
}) => {
  const actions: IFlowAction[] = []
  const findAction = (id: string) => {
    const action = getActionById(id)
    if (!action) return
    if (action.actionStore.type === type) {
      actions.push(action)
    }
    action.actionStore.nextIds.forEach(findAction)
  }
  findAction(id)
  return actions
}
